var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "decommissionModal",
        size: "md",
        "content-class": "sub-menu-bg-blue-transparent dc-modal",
        title: "Decommission Serial Number",
        "hide-footer": "",
        "no-fade": "",
        "header-close-variant": "light",
      },
    },
    [
      _c("div", { staticClass: "dc-body" }, [
        _c(
          "div",
          { staticClass: "dc-warning-strip" },
          [
            _c("fa", {
              staticClass: "dc-warning-icon",
              attrs: { icon: ["fas", "exclamation-triangle"] },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v("This will permanently decommission the system."),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dc-info-card" }, [
          _c("div", { staticClass: "dc-info-row" }, [
            _c("span", { staticClass: "dc-label" }, [_vm._v("System")]),
            _vm._v(" "),
            _c("span", { staticClass: "dc-value" }, [
              _vm._v(_vm._s(_vm.system)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dc-info-row" }, [
            _c("span", { staticClass: "dc-label" }, [_vm._v("Scanner")]),
            _vm._v(" "),
            _c("span", { staticClass: "dc-value" }, [
              _vm._v(_vm._s(_vm.scanner)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dc-info-row" }, [
            _c("span", { staticClass: "dc-label" }, [_vm._v("Serial No.")]),
            _vm._v(" "),
            _c("span", { staticClass: "dc-value" }, [
              _vm._v(_vm._s(_vm.serialNumber)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "dc-confirm-text" }, [
          _vm._v("\n      System "),
          _c("b", { staticClass: "dc-highlight" }, [
            _vm._v(_vm._s(_vm.system)),
          ]),
          _vm._v(" with Scanner\n      "),
          _c("b", { staticClass: "dc-highlight" }, [
            _vm._v(_vm._s(_vm.scanner)),
          ]),
          _vm._v(" and Serial Number\n      "),
          _c("b", { staticClass: "dc-highlight" }, [
            _vm._v(_vm._s(_vm.serialNumber)),
          ]),
          _vm._v(" will be set to\n      "),
          _c("b", { staticClass: "dc-highlight dc-highlight--danger" }, [
            _vm._v("DECOMMISSIONED"),
          ]),
          _vm._v(".\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dc-actions" },
          [
            _c(
              "b-button",
              {
                staticClass: "dc-confirm-btn",
                on: {
                  click: function ($event) {
                    return _vm.submitDecommission()
                  },
                },
              },
              [_vm._v("\n        Confirm Decommission\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }